import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import TableNotificationState from './table';
import { BodyNotificationStateVM } from 'practice/view-models/practice-detail';
import { DateTime } from 'luxon';

interface AccordionNotificationStateProps {
  disabled?: boolean;
  notificationState?: BodyNotificationStateVM[];
  ultimoScarico: DateTime | null;
}

const AccordionNotificationStateComponent = ({
  disabled = false,
  notificationState = [],
  ultimoScarico,
}: AccordionNotificationStateProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="accordion-notification-status-content"
        id="accordion-notification-status-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Stato avanzamento delle notifiche</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <TableNotificationState disabled={disabled} data={notificationState} />
        <Typography className="pmi-text-center">
          {ultimoScarico
            ? `Ultimo scarico delle notifiche effettuato il ${ultimoScarico.toFormat(
                'dd/MM/yyyy'
              )} alle ore ${ultimoScarico.toFormat('HH:mm')}`
            : ''}
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
};

AccordionNotificationStateComponent.displayName = 'accordion notification state';

const AccordionNotificationState = memo(AccordionNotificationStateComponent);

export default AccordionNotificationState;
